<template>
  <section id="NavBar">
    <b-container class="d-flex flex-column">

      <div>
        <div class="pointerCursor float-right mt-3 mr-lg-3">
          <img @click="setLanguage('br')" src="../assets/image/flag/shiny/32/BR.png" alt=""/>
          <img class="ml-1" @click="setLanguage('en')" src="../assets/image/flag/shiny/32/US.png" alt=""/>
        </div>
      </div>

      <div class="">
        <b-navbar toggleable="xl" type="light" variant="default">
          <b-navbar-brand class="pointerCursor">
            <img @click.prevent="goHome" class="logoAdjust" src="../assets/logo/easyRemessa-logo.png" alt="easyRemessa"
                 id="v-step-1"/>
          </b-navbar-brand>

          <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

          <b-collapse id="nav-collapse" is-nav>
            <b-navbar-nav class="text-uppercase ml-auto">
              <router-link to="/">
                <b-nav-item @click.prevent="goHome" href="/"><p>Home</p></b-nav-item>
              </router-link>

              <router-link to="/blog">
                <b-nav-item href="/blog"><p>Blog</p></b-nav-item>
              </router-link>

              <router-link to="/pricing">
                <b-nav-item href="/pricing"
                ><p>{{ $t("navbar.menu.pricing") }}</p></b-nav-item
                >
              </router-link>

              <router-link to="/how_it_works">
                <b-nav-item href="/how_it_works"
                ><p>{{ $t("navbar.menu.how_it_works") }}</p></b-nav-item
                >
              </router-link>

              <b-nav-item-dropdown :text="$t('navbar.menu.cs')" right id="t-4">
                <router-link to="/faq">
                  <b-dropdown-item href="/faq">{{ $t("navbar.menu.faq") }}</b-dropdown-item>
                </router-link>
                <router-link to="/contact">
                  <b-dropdown-item href="/contact">{{ $t("navbar.menu.contact") }}</b-dropdown-item>
                </router-link>
                <b-dropdown-divider></b-dropdown-divider>
                <router-link to="/about">
                  <b-dropdown-item href="/about">{{ $t("navbar.menu.about_us") }}</b-dropdown-item>
                </router-link>
              </b-nav-item-dropdown>


            </b-navbar-nav>


            <!-- Right aligned nav items -->
            <b-navbar-nav class="ml-auto">
              <div v-if="is_logged_in">

                <b-button  to="/dashboard" size="sm" class="my-2 my-sm-0 ml-2 font-weight-bold text-uppercase" variant="success">
                  {{ $t("navbar.menu.your_dashboard") }} <i class="ml-1 fas fa-chevron-double-right"></i
                ></b-button>

                <!--              <b-button href="/dashboard" size="md" class="my-2 my-sm-0 ml-2" variant="danger"> <i class="align-middle ml-1 fas fa-sign-out-alt"></i></b-button>-->
              </div>

              <div v-else class="heightFix">


                  <router-link to="/login">
                    <b-button size="sm" class="my-2 my-sm-1 ml-2 text-uppercase fontMedium" variant="outline-success">{{ $t("navbar.menu.login") }}</b-button>
                  </router-link>

<!--                  <router-link to="/register">-->
<!--                    <b-button size="sm" class="my-2 my-sm-1 ml-2 text-uppercase fontMedium" variant="success">-->
<!--                      {{ $t("navbar.menu.login_or_register") }}-->
<!--                    </b-button>-->
<!--                  </router-link>-->

<!--                <router-link to="/login">-->
<!--                  <b-button size="sm" style="font-weight: 500" class="my-2 my-sm-1 ml-2 text-uppercase" variant="success"> {{ $t("navbar.menu.login") }}  <i class="mx-1 fas fa-sign-in"></i> </b-button>-->
<!--                </router-link>-->

<!--                <b-dropdown  variant="link" class="">-->
<!--                  <template #button-content>-->
<!--&lt;!&ndash;                    <img  src="../assets/image/flag/shiny/32/BR.png" alt=""/>&ndash;&gt;-->
<!--                    {{getLanguageIcon}}-->
<!--                  </template>-->
<!--                  <b-dropdown-item @click="setLanguage('br')"> <img  src="../assets/image/flag/shiny/32/BR.png" alt=""/> Portuguese</b-dropdown-item>-->
<!--                  <b-dropdown-item @click="setLanguage('en')"> <img  src="../assets/image/flag/shiny/32/US.png" alt=""/> English</b-dropdown-item>-->
<!--                </b-dropdown>-->
<!--                <router-link to="/register">-->
<!--                  <b-button size="sm" class="my-2 my-sm-1 ml-2" variant="success">-->
<!--                    {{ $t("navbar.menu.login_or_register") }}-->
<!--                  </b-button>-->
<!--                </router-link>-->
              </div>
            </b-navbar-nav>
          </b-collapse>
        </b-navbar>
      </div>
    </b-container>
  </section>
</template>

<script>
export default {
  name: "NavBar",
  props: {},
  methods: {
    setLanguage: function (language) {
      this.$store.dispatch("SetActiveLanguage", language);
    },
    goHome: function () {
      this.$store.dispatch("SetDoingPersonalTransferStatus", false);
      this.$store.dispatch("SetPayingBillStatus", false);
      this.$router.push("/").catch(() => {});
    }
  },
  data() {
    return {
      name: "John"
    };
  },
  computed: {
    is_logged_in() {
      return this.$store.getters.GetLoggedIn;
    },
    getLanguageIcon() {
      const language = this.$store.getters.GetActiveLanguage.toUpperCase();
      const icon = '../assets/image/flag/shiny/32/BR.png';
      return  language
    }
  }
};
</script>

<style lang="scss">
.heightFix {
  margin-top: -3px !important;
}

.fontMedium {
  font-weight: 600;
}

.logoAdjust {
  margin-top: -10px;
  height: 60px;
}

@media screen and (max-width: 640px) {
  .logoAdjust {
    height: 45px;
  }
}

.btn.focus,
.btn:focus {
  box-shadow: none !important;
  outline: none !important;
}

a:hover {
  /*color: #0056b3;*/
  text-decoration: none !important;
}

.pointerCursor img {
  cursor: pointer;
}

.btn-login {
  position: relative;
  z-index: 10;

  &::after {
    content: "";
    position: absolute;
    bottom: 0px;
    left: 0;
    right: 0;
    height: 0%;
    background-color: $green;
    transition: height 0.3s ease-in-out, border-radius 0.3s ease-in-out;
    z-index: -1;
    border-radius: 50% 50% 0 0;
    box-shadow: 0px 5px 5px 0 #CDCDCD;
  }

  &:hover {
    background-color: transparent !important;

    &::after{
      height: 100%;
      border-radius: 0;
    }
  }
}

#NavBar .nav-link {
  color: #2b2b2b !important;
  font-size: 0.95rem;
  font-weight: 600;
  position: relative !important;
  transition: color 0.3s ease;

  &:hover {
    color: $green !important;
  }

  &::before {
    content: '';
    position: absolute;
    bottom: 0;
    left: 5%;
    height: 1px;
    width: 90%;
    transform-origin: right;
    background-color: $green;
    transform: scale(0);
    transition: transform 0.42s ease-in-out;
  }

  p {
    margin: 0;
  }
}

@media screen and (min-width: 1199px) {
  #NavBar .nav-link {
    &:hover::before{
      transform-origin: left;
      transform: scale(1);
    }
  }
}

.dropdown-menu {
  top: 70% !important;
  min-width: 100% !important;
  padding: 5px;
  position: relative;
  animation: fold 1.75s linear both;
}

.navbar .dropdown-menu {
  top: 70% !important;
}

.router-link-exact-active li a p{
  color: #47AF46 !important;
  font-weight: 700;
}

@media screen and (max-width: 480px) {
  .navbar {
    padding: 0.75rem 0 !important;
  }
}

@keyframes fold {
  0% {
    transform: matrix3d(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
    opacity: 0;
  }
  3.8% {
    transform: matrix3d(0.246, 0, 0, 0, 0, 0.246, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
    opacity: 0.1;
  }
  4.3% {
    transform: matrix3d(0.306, 0, 0, 0, 0, 0.306, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
    opacity: 0.2;
  }
  5.71% {
    transform: matrix3d(0.483, 0, 0, 0, 0, 0.483, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
    opacity: 0.3;
  }
  7.56% {
    transform: matrix3d(0.712, 0, 0, 0, 0, 0.712, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
    opacity: 0.4;
  }
  8.61% {
    transform: matrix3d(0.827, 0, 0, 0, 0, 0.827, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
    opacity: 0.5;
  }
  9.46% {
    transform: matrix3d(0.908, 0, 0, 0, 0, 0.908, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
    opacity: 0.6;
  }
  11.36% {
    transform: matrix3d(1.047, 0, 0, 0, 0, 1.047, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
    opacity: 0.7;
  }
  12.91% {
    transform: matrix3d(1.118, 0, 0, 0, 0, 1.118, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
    opacity: 0.8;
  }
  15.12% {
    transform: matrix3d(1.164, 0, 0, 0, 0, 1.164, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
    opacity: 0.9;
  }
  17.22% {
    transform: matrix3d(1.166, 0, 0, 0, 0, 1.166, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
    opacity: 1;
  }
  25.13% {
    transform: matrix3d(1.059, 0, 0, 0, 0, 1.059, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
  }
  28.33% {
    transform: matrix3d(1.024, 0, 0, 0, 0, 1.024, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
  }
  35.14% {
    transform: matrix3d(0.993, 0, 0, 0, 0, 0.993, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
  }
  39.44% {
    transform: matrix3d(0.991, 0, 0, 0, 0, 0.991, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
  }
  50% {
    transform: matrix3d(0.998, 0, 0, 0, 0, 0.998, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
  }
  61.66% {
    transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
  }
  83.98% {
    transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
  }
  100% {
    transform: matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
  }
}

</style>
